import { ThemeOptions } from '@material-ui/core/styles/createTheme';

export const graoEspressoTheme: ThemeOptions = {
  palette: {
    primary: {
      main: '#5c2e22',
    },
    secondary: {
      main: '#f08203',
    },
    /**
     * @todo add tertiary do cliente
     */
    tertiary: {
      main: '#E2E543',
    },
    additionalColors: {
      promoHighligts: '#f58220',
    },
  },
};
